// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__LJU2E","thickDivider":"divider_thickDivider__PneMx"};